// extracted by css-extract-rspack-plugin
export default {"cls1":"live_stats-cls1_NdN","cls2":"live_stats-cls2_1dQ live_stats-cls1_NdN","live-stats-pulse":"live_stats-live-stats-pulse_x_V"};